import styles from "../styles/headerTabList.module.css";
import { HeaderTabListItem } from "./headerTabListItem";

export interface TAB {
  icon: JSX.Element;
  title: string;
  navigation?: string;
  dropDown?: {
    title: string;
    navigation: string;
  }[];
}

export const HeaderTabList = ({ tabs, navigate }: { tabs: TAB[]; navigate: Function }) => {
  return (
    <div className={styles.wrapper}>
      {tabs.map((tab, index) => (
        <HeaderTabListItem key={index} navigate={navigate} tab={tab} />
      ))}
    </div>
  );
};
